import invariant from 'invariant';
import { Map } from 'immutable';
import Organization from 'entities/Organization';
import type { SchoolFetchOptions } from 'clients/api/districtSchoolsSearch';
import { fetch } from 'clients/api/districtSchoolsSearch';

export type SchoolTable = {
  page: number;
  loading: boolean;
  allLoaded: boolean;
  schools: Organization[];
};

export type State = Map<Backbone$Id, SchoolTable>;
// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
export const initialState: State = new Map();

export default function reducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case 'schoolTables/INITIALIZE_TABLE': {
      return state.set(action.districtId, {
        page: 1,
        schools: [],
        loading: false,
        allLoaded: false,
      });
    }

    case 'schoolTables/LOAD_SCHOOLS_REQUEST': {
      const table = state.get(action.districtId);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ loading: true; page?: number |... Remove this comment to see the full error message
      return state.set(action.districtId, {
        ...table,
        loading: true,
      });
    }

    case 'schoolTables/LOAD_SCHOOLS_SUCCESS': {
      const table = state.get(action.districtId);
      invariant(table, 'schoolTables/LOAD_SCHOOLS_SUCCESS missing table');
      return state.set(action.districtId, {
        ...table,
        loading: false,
        page: action.options.page,
        allLoaded: action.schools.length < action.options.perPage,
        schools:
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          action.options.page === 1 ? action.schools : [].concat(table.schools, action.schools),
      });
    }

    default: {
      return state;
    }
  }
}

type InitializeTableAction = {
  type: 'schoolTables/INITIALIZE_TABLE';
  districtId: number;
};

export function initializeTable(districtId: number): InitializeTableAction {
  return {
    type: 'schoolTables/INITIALIZE_TABLE',
    districtId,
  };
}

export type LoadSchoolsRequestAction = {
  type: 'schoolTables/LOAD_SCHOOLS_REQUEST';
  districtId: number;
  options: SchoolFetchOptions;
};

export function loadSchoolsRequest(
  districtId: number,
  options: SchoolFetchOptions
): LoadSchoolsRequestAction {
  return {
    type: 'schoolTables/LOAD_SCHOOLS_REQUEST',
    districtId,
    options,
  };
}

export type LoadSchoolsSuccessAction = {
  type: 'schoolTables/LOAD_SCHOOLS_SUCCESS';
  districtId: number;
  schools: Organization[];
  options: SchoolFetchOptions;
};

export function loadSchoolsSuccess(
  districtId: number,
  schools: Organization[],
  options: SchoolFetchOptions
): LoadSchoolsSuccessAction {
  return {
    type: 'schoolTables/LOAD_SCHOOLS_SUCCESS',
    districtId,
    schools,
    options,
  };
}

export function loadSchools(districtId: number, options: SchoolFetchOptions) {
  return async (dispatch: Function) => {
    dispatch(loadSchoolsRequest(districtId, options));

    try {
      const schools = await fetch(districtId, options);
      dispatch(loadSchoolsSuccess(districtId, schools, options));
    } catch (e) {
      console.error('loadSchools failure', e);
    }
  };
}

export type SchoolTablesAction =
  | InitializeTableAction
  | LoadSchoolsRequestAction
  | LoadSchoolsSuccessAction;
